import React from "react";
import { Sport } from "../data/api";
import { BiFootball } from "react-icons/bi";
import { FaBowlingBall, FaChess, FaCommentDots } from "react-icons/fa";
import { CgPokemon } from "react-icons/cg";
import { IconType } from "react-icons/lib";
import { Center, Icon } from "@chakra-ui/react";

type Props = {
  sport: Sport;
};

interface IconLookupTable {
  [key: string]: string | IconType;
}

const iconLookup: IconLookupTable = {
  "American Football": "icon-football",
  Archery: "icon-archery",
  Badminton: "icon-badminton",
  Baking: "icon-baking",
  "Ballroom Dancing": "icon-dance",
  Basketball: "icon-basketball-1",
  Bouldering: "icon-bouldering",
  "Canoe Polo": "icon-canoe",
  "Canoe Slalom": "icon-canoe",
  "Clay Pigeon Shooting": "icon-shooting",
  Climbing: "icon-climbing",
  "Comedy Institute": "icon-theatre",
  Cricket: "icon-cricket",
  "Crown Green Bowls": "icon-bowl",
  Cycling: "icon-cycling",
  Dancesport: "icon-dance",
  Darts: "icon-darts",
  Debating: "icon-debate",
  "Disability Sport - Goalball": BiFootball,
  Equestrian: "icon-horse",
  Fencing: "icon-fencing",
  Football: BiFootball,
  Handball: "icon-handball",
  Hockey: "icon-hockey",
  "Indoor Football": BiFootball,
  "Indoor Frisbee": "icon-frisbee",
  "Indoor Hockey": "icon-hockey",
  Karate: "icon-martial",
  Kendo: "icon-martial",
  Lacrosse: "icon-lacrosse",
  Netball: "icon-netball",
  Octopush: "icon-swimming",
  "Pole Fitness": "icon-dance",
  Pool: "icon-pool",
  Rowing: "icon-rowing",
  "Rugby Union": "icon-rugby",
  "Rugby League": "icon-rugby",
  "Rugby Union 7s": "icon-rugby",
  Running: "icon-run",
  Sailing: "icon-sail",
  Snooker: "icon-pool",
  "Snow Sports": "icon-skiing",
  Squash: "icon-squash",
  Swimming: "icon-swimming",
  "Table Tennis": "icon-tabletennis",
  Tennis: "icon-tennis",
  Trampoline: "icon-trampoline",
  "Ultimate Frisbee": "icon-frisbee",
  "University Challenge": "icon-unichallenge",
  Volleyball: "icon-volleyball",
  "Water Polo": "icon-swimming",
  "Pokemon Society": "icon-pokemon",
  "Computer Gaming": "icon-computer",
  Boxing: "icon-boxing",
  Cheerleading: "icon-cheerleader",
  "Comedy Society": "icon-theatre",
  Futsal: BiFootball,
  Dance: "icon-dance",
  Croquet: "icon-croquet",
  "York Student Cinema": "icon-cinema",
  Golf: "icon-golf",
  "Canoe Whitewater": "icon-canoe",
  "Underwater Hockey": "icon-hockey",
  Dodgeball: "icon-handball",
  eSports: "icon-computer",
  Triathlon: "icon-run",
  Negotiating: "icon-debate",
  Chess: FaChess,
  "Vice Chancellor Bowling": FaBowlingBall,
  Pokemon: CgPokemon,
  Mooting: FaCommentDots,
};

const SportIcon = ({ sport }: Props) => {
  const iconName = sport.title as keyof typeof iconLookup;
  const icon = iconLookup[iconName];
  return (
    <Center w={16} h={16} rounded={"full"} bg="gray.900">
      {typeof icon === "string" ? (
        <i className={"icon " + icon}></i>
      ) : (
        <Icon as={icon} />
      )}
    </Center>
  );
};

export default SportIcon;
